import styled from 'styled-components';
import theme from 'styles/theme';

export const MainPageWrap = styled.div`
  section {
    & + section {
      margin-top: 70px;
    }
  }

  h3 {
    font-size: 2.4rem;
    line-height: 3.4rem;
    font-weight: 700;
    text-align: center;
    @media screen and (max-width: 375px) {
      line-height: 2.8rem;
      font-size: 2rem;
    }
  }
`;

export const BigSlideWrap = styled.div`
  position: relative;
  margin-bottom: 40px;

  .pageCounter {
    position: absolute;
    bottom: 20px;
    right: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    width: 50px;
    height: 26px;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 50px;
    text-align: center;
    font-size: 1.2rem;
    line-height: 26px;
    z-index: 10;
    span {
      color: ${theme.color.white};
    }
  }
`;

export const BigSlideContainer = styled.div`
  position: relative;
  background-image: url(${props => props.bgUrl});
  background-size: cover;
  width: 100%;
  height: 520px;
  overflow: hidden;

  img {
    width: 486px;
    height: 520px;
    object-fit: cover;
    object-position: left top;
  }
  .textWrap {
    position: absolute;
    top: 200px;
    left: 30px;
    width: 100%;
    z-index: 6;

    p {
      color: ${theme.color.white};
      font-size: 3rem;
      font-weight: 500;
      text-shadow: 0 1px 4px ${theme.color.textShadow};

      & + p {
        padding-top: 15px;
      }
      &.sub {
        font-size: 2rem;
        font-weight: 300;
        text-shadow: 0 1px 4px ${theme.color.textShadow};
      }
      &:nth-of-type(3) {
        padding-top: 30px;
      }
    }
  }
`;

export const LoanSectionWrap = styled.section`
  padding: 0 20px;
  text-align: center;

  ul {
    margin-top: 40px;
    border-top: 1px solid #d0d0d0;
    li {
      list-style: none;
      display: flex;
      gap: 13px;
      position: relative;
      margin-left: 0;
      padding: 15px 0;
      border-bottom: 1px solid #d0d0d0;

      img {
        width: 40px;
        height: 40px;
      }

      dl {
        padding-right: 34px;
        dt {
          font-size: 1.7rem;
          line-height: 2.4rem;
          font-weight: 700;
        }
        dd {
          padding-top: 8px;
          color: #555;
          font-size: 1.3rem;
          line-height: 1.8rem;
          span {
            display: inline-block;
            position: relative;
            & + span {
              padding-left: 14px;
              &::before {
                content: '';
                position: absolute;
                top: 4px;
                left: 7px;
                width: 1px;
                height: 12px;
                background: #ccc;
              }
            }
          }
        }
      }

      .btnMove {
        position: absolute;
        right: 0;
        top: 18px;
      }
    }
  }

  .btnCheckMyLoanLimit {
    margin-top: 40px;
    width: 220px;
    height: 45px;
    border: 1px solid ${theme.color.aizenBlue};
    border-radius: 50px;
    text-align: center;
    font-weight: 700;
    color: ${theme.color.aizenBlue};
  }
`;

export const SellerMallWrap = styled.section`
  position: relative;
  padding: 0 20px;

  .subTitle {
    margin-top: 20px;
    line-height: 2.4rem;
    font-size: 1.6rem;
    text-align: center;
    @media screen and (max-width: 375px) {
      line-height: 2.1rem;
      font-size: 1.2rem;
    }
  }

  .imageArea {
    padding: 40px 20px;
    margin: 40px 0 0;
    border: 1px solid ${theme.borderColor.lightGrey};
    border-radius: 10px;
    line-height: 0;
    text-align: center;

    @media screen and (max-width: 375px) {
      padding: 30px 20px;
    }
  }
`;

export const FAQMainWrap = styled.section`
  padding: 0 20px;
  text-align: center;

  dl {
    padding-bottom: 70px;
    border-bottom: 1px solid ${theme.borderColor.lightGrey};
    dt {
      padding: 50px 0 20px;
      font-size: 2.1rem;
      line-height: 2.9rem;
      text-align: center;
      @media screen and (max-width: 375px) {
        font-size: 1.6rem;
        line-height: 2.4rem;
      }
    }
    dd {
      font-size: 1.4rem;
      line-height: 2.2rem;
      text-align: center;
      white-space: pre-line;
      @media screen and (max-width: 375px) {
        font-size: 1.2rem;
        line-height: 2rem;
      }

      button {
        display: block;
        width: 220px;
        height: 45px;
        margin: 29px auto 0;
        border: 1px solid ${theme.color.blue};
        border-radius: 23px;
        text-align: center;
        color: ${theme.color.blue};
        font-size: 1.8rem;
        font-weight: bold;

        @media screen and (max-width: 375px) {
          margin: 20px auto 0;
          width: 180px;
          height: 40px;
          font-size: 1.4rem;
        }
      }
    }
  }
`;
